import React from 'react';
import Modal from '../Modal';
import Form, { TextField, TagColour, TagIcon, Actions, RequiredValidator, ULID, Switch } from '../Form';
import { useTags } from '../../Data/Tags';

const AddEditTag = ({isOpen, setIsOpen, tag, onSave}) => {
    return <Modal title={tag?.id ? 'Edit tag' : 'Add Tag'} isOpen={isOpen} setIsOpen={setIsOpen} dismissible>
        {isOpen && <Inner {...{tag, onSave}} />}
    </Modal>
}

const Inner = ({tag, onSave}) => {
    const {saveTag} = useTags();

    const handleSave = async (data) => {
        await saveTag(data, tag?.id);
        await onSave && onSave(data);
    }

    return <Form data={tag} onSubmit={handleSave} closeModalOnSubmit>
        <ULID name="id" />
        <TextField name="name" label="Tag Name" validators={[RequiredValidator]} />
        <TagColour name="colour" label="Tag Colour" validators={[RequiredValidator]} />
        <TagIcon name="icon" label="Tag Icon" validators={[RequiredValidator]} />
        <Switch name="dismissible"
            label="Temporary Tag"
            innerLabel="Allow workers to quickly remove this tag in the work view, even without permission to edit customers."
        />
        <Actions submit={{label: 'Save'}} />
    </Form>
}

export default AddEditTag;